module.exports = __webpack_public_path__ + "static/footer-background-3b7287221d77de0ec8f19379c0bff525.png";